import React, { useEffect, useState } from 'react'
import GradeSelector from './gradeSelector'
import WorksheetTopicSelector from './topicSelector'
import './styles.scss'
import { useAppMediaProvider } from '../../../baseStyles/AppMediaProvider';
import Filter from './filter.svg';
import FilterHollowLight from './filter-hollow-light.svg';
import FilterHollowDark from './filter-hollow-dark.svg'
import Cross from './cross.svg';
import { usePrintableWorksheetsState } from 'printableWorksheets/state';
import SubjectSelector from './subjectSelector';
import { WorksheetsEnvironment } from 'printableWorksheets';

const WorksheetsNav = () => {
  const {isMobile} = useAppMediaProvider();
  const { activeGrade, activeBreadcrumb, subjectCode, showHeader, setShowHeader, worksheetsEnvironment} = usePrintableWorksheetsState();
  return (
    <>{isMobile ? <div className='worksheet-mobile-options'>
      <div id="searchIconPortal">
      </div>
    <div onClick={()=>{
          const elem = document.getElementById('ws-header');
          if(elem) {
            elem.scrollIntoView();
          }
          setShowHeader(true)
      }}>
        <Filter/>
        </div>
    </div> : null}
    <div className={`worksheets-nav ${showHeader ? 'show-on-mobile' : ''}`} >
      
      {isMobile ? <div className='worksheet-mobile-header'>
        <div className='mobile-header-left'>
          {worksheetsEnvironment === WorksheetsEnvironment.TEACHER_DASHBOARD ? (<FilterHollowDark />) : (<FilterHollowLight />)}
          Filter
        </div>
        <div className='mobile-header-center'>
             {activeGrade} <div className='circle'/> {subjectCode} <div className='circle'/> {activeBreadcrumb?.[activeBreadcrumb?.length-1]?.title}
        </div>
        <div onClick={()=>{
            setShowHeader(false)
        }}>
          <Cross/>
          </div>
      </div> : null}
      {worksheetsEnvironment === WorksheetsEnvironment.TEACHER_DASHBOARD ? null :
      <div className="worksheets-nav__grade-selector">
        <GradeSelector />
      </div> }
      {(isMobile && worksheetsEnvironment !== WorksheetsEnvironment.TEACHER_DASHBOARD) ? <div className='worksheets-nav__subject-selector'> 
          <SubjectSelector/>
       </div>: null }
      <div className="worksheets-nav__topic-selector">
        <WorksheetTopicSelector />
      </div>
    </div>
    </>
  )
}

export default WorksheetsNav